import { Grid, Menu, MenuProps, styled, Typography } from "@material-ui/core";

export const SimpleMenu = (props: MenuProps) => {
  const { anchorOrigin, transformOrigin, ...otherProps } = props;
  return (
    <Menu
      getContentAnchorEl={null}
      anchorOrigin={
        anchorOrigin || {
          vertical: "top",
          horizontal: "left",
        }
      }
      transformOrigin={
        transformOrigin || {
          vertical: "top",
          horizontal: "center",
        }
      }
      {...otherProps}
    />
  );
};

export const MenuHeader = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(3),
}));

export const MenuLabel = styled(Typography)(({ theme }) => ({
  fontSize: "0.8rem",
  fontWeight: 500,
  padding: theme.spacing(0, 4),
  marginTop: theme.spacing(4),
  color: theme.palette.gray.dark,
}));
